import { useMemo, useState } from "react";
import { SortOrder } from "@common/constants";
import { BillSort, BillByCounterpartySortValue } from "@common/types/bill";

const DEFAULT_SORT = BillByCounterpartySortValue.OPEN_DESC;

export interface SortByCounterparty {
    currentSort: BillByCounterpartySortValue;
    handleSortChange: (value: BillByCounterpartySortValue) => void;
    sortExpression: BillSort | undefined;
}

export const getSortExpression = (sort: BillByCounterpartySortValue) => {
    switch (sort) {
        case BillByCounterpartySortValue.COUNTERPARTY_ASC:
            return {
                field: "counterpartyId",
                order: SortOrder.ASC,
            };
        case BillByCounterpartySortValue.COUNTERPARTY_DESC:
            return {
                field: "counterpartyId",
                order: SortOrder.DESC,
            };
        case BillByCounterpartySortValue.PAST_DUE_1_30_ASC:
            return {
                field: "pastDue1To30",
                order: SortOrder.ASC,
            };
        case BillByCounterpartySortValue.PAST_DUE_1_30_DESC:
            return {
                field: "pastDue1To30",
                order: SortOrder.DESC,
            };
        case BillByCounterpartySortValue.PAST_DUE_31_60_ASC:
            return {
                field: "pastDue31To60",
                order: SortOrder.ASC,
            };
        case BillByCounterpartySortValue.PAST_DUE_31_60_DESC:
            return {
                field: "pastDue31To60",
                order: SortOrder.DESC,
            };
        case BillByCounterpartySortValue.PAST_DUE_61_PLUS_ASC:
            return {
                field: "pastDue61Plus",
                order: SortOrder.ASC,
            };
        case BillByCounterpartySortValue.PAST_DUE_61_PLUS_DESC:
            return {
                field: "pastDue61Plus",
                order: SortOrder.DESC,
            };
        case BillByCounterpartySortValue.OVERDUE_ASC:
            return {
                field: "overdue",
                order: SortOrder.ASC,
            };
        case BillByCounterpartySortValue.OVERDUE_DESC:
            return {
                field: "overdue",
                order: SortOrder.DESC,
            };
        case BillByCounterpartySortValue.PAID_ASC:
            return {
                field: "paid",
                order: SortOrder.ASC,
            };
        case BillByCounterpartySortValue.PAID_DESC:
            return {
                field: "paid",
                order: SortOrder.DESC,
            };
        case BillByCounterpartySortValue.BILLS_COUNT_ASC:
            return {
                field: "billCount",
                order: SortOrder.ASC,
            };
        case BillByCounterpartySortValue.BILLS_COUNT_DESC:
            return {
                field: "billCount",
                order: SortOrder.DESC,
            };
        case BillByCounterpartySortValue.OPEN_ASC:
            return {
                field: "open",
                order: SortOrder.ASC,
            };
        case BillByCounterpartySortValue.OPEN_DESC:
        default:
            return {
                field: "open",
                order: SortOrder.DESC,
            };
    }
};

export function useSortByCounterparty(
    defaultSort: BillByCounterpartySortValue = DEFAULT_SORT,
): SortByCounterparty {
    const [currentSort, setCurrentSort] =
        useState<BillByCounterpartySortValue>(defaultSort);

    const sortExpression: BillSort | undefined = useMemo(
        () => getSortExpression(currentSort),
        [currentSort],
    );

    return {
        currentSort,
        handleSortChange: setCurrentSort,
        sortExpression,
    };
}
